// SSR-safe motion environment helpers. Every function returns the "no motion" answer during the
// Node prerender, so markup rendered at build time is always the final, visible state.

const hasWindow = () => typeof window !== "undefined";

const mq = (query: string): boolean =>
  hasWindow() && typeof window.matchMedia === "function" && window.matchMedia(query).matches;

export const MOBILE_QUERY = "(max-width: 1080px)";
export const PHONE_QUERY = "(max-width: 820px)";

export const prefersReducedMotion = (): boolean => mq("(prefers-reduced-motion: reduce)");

/** True when the head script armed the reveal system (`html.anim`): JS on, motion allowed. */
export const motionOn = (): boolean =>
  hasWindow() && document.documentElement.classList.contains("anim");

export const isMobileMQ = (): boolean => mq(MOBILE_QUERY);

export const isPhoneMQ = (): boolean => mq(PHONE_QUERY);

export const clamp = (v: number, a: number, b: number): number => Math.min(b, Math.max(a, v));
